import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { loadDeviceKey } from './lib/device';
import { initPwa } from './lib/pwa';
import './index.css';

initPwa();
// The device key is ready before the first requests leave (they wait for it briefly).
void loadDeviceKey();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
